import React from 'react';
import { Block, BLOCKS, Inline } from '@contentful/rich-text-types';
import classNames from 'classnames';

import { ILearningCenterAboutBlockFields } from '@/types/contentful';

import RichText from '../../../RichText';

import { SearchBar } from '../SearchBar';
import { FeaturedPosts } from '../FeaturedPosts';

export function LearningCenterAbout({
  headingText,
  description,
  searchBar,
  newPopularArticles
}: ILearningCenterAboutBlockFields) {
  return (
    <div className="block-container my-3 tablet:-my-7" data-testid="lc-about">
      <div className="layout flex-[1_0_100%] flex-col !flex-nowrap tablet:flex-row tablet:items-start tablet:px-4 desktop:px-12">
        <div
          className={classNames('column w-full flex-col', {
            'tablet:w-[58.33333333333333%] tablet:flex-shrink-0':
              headingText || description,
            'tablet:w-full tablet:flex-shrink-0': !(headingText || description)
          })}
        >
          {searchBar && (
            <div className="relative w-full px-4 tablet:pl-4 tablet:pr-0 desktop:px-0">
              <div className="relative w-full">
                <SearchBar filters={searchBar.fields} />
              </div>
            </div>
          )}
          {(headingText || description) && (
            <div className="mt-12 grid gap-6 px-4 pb-8 pt-2 desktop:mt-24">
              <h2 className="heading-2 font-medium">{headingText}</h2>

              {description && (
                <div>
                  <RichText
                    data={description}
                    overrideOptions={{
                      [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => (
                        <p className="whitespace-pre-wrap break-words text-base font-normal tablet:text-xl [&:not(:last-child)]:mb-6">
                          {children}
                        </p>
                      )
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>

        {newPopularArticles && (
          <>
            <div className="hidden min-w-8 max-w-24 flex-shrink flex-grow tablet:block" />
            <div className="column w-full justify-center px-4 tablet:w-[41.666666666666664%] tablet:flex-shrink-0 tablet:pl-0 tablet:pr-4 desktop:px-0">
              <FeaturedPosts {...newPopularArticles?.fields} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
